
module.exports = require('./lib/time-delta.js');
